import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IApiResponse } from '../models/api-response';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SamlService {

  _samlApiBaseUrl = environment.servicesUrl.authentication.endsWith('/')
    ? `${environment.servicesUrl.authentication}saml`
    : `${environment.servicesUrl.authentication}/saml`;

  constructor(
    private http: HttpClient) {

  }

  public getSfAccessToken() {
    return this.http.get<IApiResponse<string>>(`${this._samlApiBaseUrl}/GetSalesforceAccessToken`);
  }

  public getLogoutUrl() {
    return this.http.get<IApiResponse<string>>(`${this._samlApiBaseUrl}/SLO`);
  }

  public getLoggedInUserHoSDStatus(): Observable<IApiResponse<boolean>> {
    return this.http.get<IApiResponse<boolean>>(`${this._samlApiBaseUrl}/GetLoggedInUserHoSDStatus`);
  }
}
